import React from "react";
import Footer from "../components/Footer";
import SharedNavbar from "../components/SharedNavbar";
import "../App.css";
import HowToUse from "./HowToUse";

const HowToUsePage = () => {

  return (
    <div className="how-to-use-page">
      {/* Navigation */}
      <SharedNavbar activePage="how-to" />

      {/* Main Content derived from existing component, but we override padding since the component has it hardcoded */}
      <div style={{ paddingTop: "0" }}>
        <HowToUse />
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HowToUsePage;
